import React, { useEffect } from 'react';
import { Graph } from './Graph';
import { Container } from './styles';
interface GraphicMapProps {
  data: any
}
export const GraphicMap: React.FC<GraphicMapProps> = ({data}) => {
  return (
    <Container>
      { data !== undefined &&(
        <Graph data={data} />
      )}
     { data == undefined &&(
        <p>Carregando...</p>
      )}

    </Container>)
};
